import React from "react";
import {Box, Heading, Form, FormField, Button, CheckBox, Layer as LayerGrommet, Text, DateInput} from "grommet";
import {QUERY_PACKAGE_LIST, UPSERT_USER_PACKAGE} from "./UserGQL.js";
import {FormClose} from "grommet-icons";
import { useLazyQuery,useMutation } from '@apollo/client';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import {extractIdFormData} from "../../../utilis/utils";
import moment from "moment";
export default function AddUserPackages(props) {

    const [formData,setFormData]=React.useState({paid:false,user:props?.id});
    const [mutationUpsertUserPack]=useMutation(UPSERT_USER_PACKAGE);
    const [packageList,setPackageList] = React.useState([])

  const [ queryPackageList
  ]  = useLazyQuery(QUERY_PACKAGE_LIST, {
  fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if(data["clubmate_clubmatepackage_clubmatepackage"]){
        setPackageList(data["clubmate_clubmatepackage_clubmatepackage"]);
      }
    },
    onError:(error)=>{
      console.log(error);
    },
    notifyOnNetworkStatusChange: true, // did the work
  });

  
  function onUpsertPackUser(){
    let obj= extractIdFormData(formData,true,true);
    delete obj?.variables?.input["_Typename"]
    if(!formData?.package){
        alert("compila tutti i campi");
    } else{
        console.log("OBJ",obj)
        mutationUpsertUserPack(obj)
        .then((value)=>{
          //setFormData(value.data[`${tenant}`][`upsertUser${tenantTypeFirstUpperCase}`])
          alert("Pacchetto aggiunto correttamente");
          if(props?.reloadQuery){
              props?.reloadQuery()
          }
          onEscLayer();
        }).catch((value)=>{
          console.error(value);
          alert("Errore durante l'operazione");
        })
    }
    /*
   
    */
  }

  React.useEffect(()=>{
    queryPackageList()
  },[])

  function onEscLayer(){
    if(props.onEscLayer){
        props.onEscLayer();
    }
    setFormData({});
  }

  function handleChange(value,name){
      setFormData({...formData,[name]:value})
  }

  function handleChangeCheckbox(event){
    setFormData({...formData,[event.target.name]:event.target.checked})
}

  
  return (
    <LayerGrommet style={{height: "60%", width: '50%'}} onEscLayer={props?.onEscLayer} onClickOutside={props?.onEscLayer}>
    <Box height="100%" round pad="medium" direction="column" background="#ffffff" align="center" overflow="auto">
      <Button alignSelf="end" icon={<FormClose color="grey" size="35px" onClick={onEscLayer}/>}></Button>
      <Heading level="2" margin="none" size="small" style={{fontWeight:'bold',textTransform: 'uppercase'}}>
        <Box direction="row" gap="large">
          {"Inserisci un abbonamento"}
          {/*<Button label="Scarica modello" href={"./modelliCsv/Modello_Personale.csv"} style={{width:'200px',fontSize:'20px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase',textAlign:"center"}}></Button>  */}
        </Box>
      </Heading>
      <Box align="center" gap="small">
          <Box direction="row" gap="small" pad="small" align="center">
              <Text>Seleziona data iscrizione</Text>
              <DateInput
                  format="dd/mm/yyyy"
                  value={formData?.date_of_subscription || moment().startOf('month').format("MM-DD-YYYY")}
                  onChange={({ value }) => setFormData({...formData,date_of_subscription:moment(value).format("YYYY-MM-DD")})}
                  name="data_inizo"
                  id="data_inizio"
              />
          </Box>
        <Form style={{marginTop:"50px"}}>
            <Box gap="medium" direction="horizontal" align="center" style={{marginTop:30+"px"}}>
            <FormField required label="">
                <Autocomplete
                    disablePortal
                    id="packages"
                    value={formData?.package || null}
                    getOptionLabel={(option) => option?.name || ""}
                    options={packageList}
                    sx={{ width: 300 }}
                    renderInput={(params) => <TextField {...params} label="Pacchetto" />}
                    onChange={(event, value) => handleChange(value,"package")}
                />
            </FormField>
                <FormField required label="">
                    <CheckBox
                        name="paid"
                        checked={formData?.paid}
                        label="Pagato"
                        onChange={(event,value) => handleChangeCheckbox(event)}
                        />
                </FormField>
            </Box>
      </Form>
      <Box direction="row" gap="medium" alignSelf="center" style={{marginTop:30+"px"}}>
          <Button label={"Aggiungi"} onClick={onUpsertPackUser} style={{width:'170px',height:'34px',fontSize:'18px',background:'#f8b20e',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}/>
      </Box>
      </Box>
     
    </Box>
    </LayerGrommet>
  )
}

/*
 <Select
                  options={packageList}
                  value={selectedPackage}
                  multiple={true}
                  labelKey={"name"}
                  valueKey={"name"}
                  closeOnChange={false}
                  onChange={( option ) => handleChange(option)}
                />
                */

